export default (props) => ({
    ...props,
    form: {
        colors: {
            //! Box Shadow
            boxShadowColor: '#D9DED8',
            //! Empty Text Color
            emptyTextColor: '#8C9B8B',
            //! Message colors
            successMessageColor: '#4CAF50',
            successMessageBorderColor: '#4CAF50',
            successMessageBgColor: 'rgba(76, 175, 80, 0.1)',
            errorMessageColor: '#DE554E',
            errorMessageBorderColor: '#DE554E',
            errorMessageBgColor: 'rgba(222, 85, 78, 0.1)',
            //! Label
            labelColor: '#3E583C',
            labelHoverColor: '',
            labelFocusColor: '',
            labelActiveColor: '',
            labelErrorColor: '#DE554E',
            labelDisabledColor: '#B2BDB1',
            //! Input
            inputColor: '#3E583C',
            inputHoverColor: '',
            inputFocusColor: '#3E583C',
            inputActiveColor: '',
            inputErrorColor: '#DE554E',
            inputDisabledColor: '#B2BDB1',
            inputPlaceholderColor: '#B2BDB1',
            inputPlaceholderHoverColor: '',
            inputPlaceholderFocusColor: '#3E583C',
            inputPlaceholderActiveColor: '',
            inputPlaceholderErrorColor: '#DE554E',
            inputPlaceholderDisabledColor: '',
            inputBorderColor: '#B2BDB1',
            inputBorderHoverColor: '',
            inputBorderFocusColor: '',
            inputBorderActiveColor: '',
            inputBorderErrorColor: '#DE554E',
            inputBorderDisabledColor: '#F5F6F5',
            inputBgColor: '#FFFFFB',
            inputHoverBgColor: '',
            inputFocusBgColor: '',
            inputActiveBgColor: '',
            inputErrorBgColor: 'rgb(250, 243, 240)',
            inputDisabledBgColor: '#F5F6F5',
            //! Select
            selectColor: '#3E583C',
            selectHoverColor: '',
            selectFocusColor: '#3E583C',
            selectActiveColor: '',
            selectErrorColor: '#DE554E',
            selectDisabledColor: '',
            selectPlaceholderColor: '#B2BDB1',
            selectPlaceholderHoverColor: '',
            selectPlaceholderFocusColor: '#3E583C',
            selectPlaceholderActiveColor: '',
            selectPlaceholderErrorColor: '#DE554E',
            selectPlaceholderDisabledColor: '',
            selectBorderColor: '#B2BDB1',
            selectBorderHoverColor: '#B2BDB1',
            selectBorderFocusColor: '#3E583C',
            selectBorderActiveColor: '',
            selectBorderErrorColor: '#DE554E',
            selectBorderDisabledColor: '#F5F6F5',
            selectBgColor: '#FFFFFB',
            selectHoverBgColor: '',
            selectFocusBgColor: '',
            selectActiveBgColor: '',
            selectErrorBgColor: 'rgb(250, 243, 240)',
            selectDisabledBgColor: '#F5F6F5',
            selectOptionColor: '#657A64',
            selectOptionHoverColor: '',
            selectOptionFocusColor: '',
            selectOptionActiveColor: '#3E583C',
            selectOptionErrorColor: '#DE554E',
            selectOptionDisabledColor: '',
            selectOptionBgColor: '#FFFFFB',
            selectOptionHoverBgColor: '',
            selectOptionFocusBgColor: '#ECEFEC',
            selectOptionActiveBgColor: '',
            selectOptionErrorBgColor: 'rgb(250, 243, 240)',
            selectOptionDisabledBgColor: '',
            //! Radio
            radioBorderColor: '#B2BDB1',
            radioBorderActiveColor: '#3E583C',
            radioBgColor: '#FFFFFB',
            radioActiveBgColor: '#3E583C',
            //! Upload
            uploadBgColor: 'rgba(0, 0, 0, 0.02)',
            uploadBorderColor: '#d9d9d9',
            ...props.form?.colors,
        },
        mediaQuery: {
            form_DesktopSizeXL: '2560px',
            form_DesktopSizeL: '1920px',
            form_DesktopSizeM: '1510px',
            form_DesktopSizeS: '1440px',
            form_DesktopSizeXS: '1280px',
            form_TabletSize: '1024px',
            form_TabletSizeS: '768px',
            form_DesktopSizeXLMin: '2559px',
            form_DesktopSizeLMin: '1919px',
            form_DesktopSizeMMin: '1509px',
            form_DesktopSizeSMin: '1439px',
            form_DesktopSizeXSMin: '1279px',
            form_TabletSizeMin: '1023px',
            form_TabletSizeSMin: '767px',
            ...props.form?.mediaQuery,
        },
    },
});
//# sourceMappingURL=theme.js.map